var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.isSennderTheme)?_vm._t("sennder"):_vm._e(),(_vm.isPosteTheme)?_vm._t("poste"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }